import { render } from "./Header.vue?vue&type=template&id=6cf3cc8a"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6cf3cc8a&lang=scss"
script.render = render

export default script